export enum SubscriptionPlanSelectorStyle {
  loggedOutHomepageVertical = 'logged_out_homepage_vertical',
  loggedOutHomepageHorizontal = 'logged_out_homepage_horizontal',
  choosePlan = 'choose_plan',
}
